/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {useEffect} from "react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { configState, loginState } from "../lib/State";
import axios from "axios";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";

function RegisterFindPass(props) {
  const { onCloseFindPass } = props;
  const [showInput, setShowInput] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const cid = get_cid();

  // 데이타폼
  const [data, setData] = useState({
    cid: cid,
    phone: "",
    name: "",
    auth: "",
    pass1: "",
    pass2: "",
  });

  const onInputChange = (e) => {
    setData((state) => ({ ...state, [e.target.name]: e.target.value }));
  };

  const onAuth = async () => {
        
    let result = await axios.post(configState.api+"/gympass/findpw_auth", {
      ...data,
      cid: cid,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);   
      return; 
    }    
    else {
      Swal.fire('인증번호를 발송했습니다.');      
    }
    setShowInput(false);
    setShowReset(true);
  };

  const onPassReset = async () => {
    let result = await axios.post(configState.api+"/gympass/findpw_reset", {
      ...data,
      cid: cid,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    }
    Swal.fire("비밀번호가 변경 되었습니다.")
      .then(() => {
        onCloseFindPass();
      })
      .catch((e) => alert(e));
  };

  useEffect(()=>{
    setShowInput(true);
  },[]);

  return (
    <Grid container direction="column" justifyContent="center">
      {showInput && (
        <>
          <Box
            css={css`
              padding-left: 10px;
              padding-top: 15px;
              font-wieght: bold;
            `}
          >
            연락처와 이름을 입력하세요.
          </Box>
          <Grid container width="100%" padding="5px">
            <TextField
              autoComplete="off"
              name="phone"
              label="연락처 ( - 없이 숫자만 입력 )"
              size="small"
              sx={{
                width: "100%",
              }}
              onChange={onInputChange}
            ></TextField>
          </Grid>
          <Grid container width="100%" padding="5px">
            <TextField
              autoComplete="off"
              name="name"
              label="이름"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onInputChange}
            ></TextField>
          </Grid>

          <Grid
            container
            display="flex"
            justifyContent="center"
            paddingTop="20px"
          >
            <Button
              variant="contained"
              sx={{ width: "40%", margin: "5px", background: "#0092a2" }}
              onClick={onAuth}
            >
              인증번호 받기
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: "40%",
                margin: "5px",
                border: "1px solid gray",
                color: "gray",
              }}
              onClick={onCloseFindPass}
            >
              취소
            </Button>
          </Grid>
        </>
      )}
      {showReset &&
      (
        <>         

          <Box
            css={css`
              padding-left: 10px;
              padding-top: 15px;
              font-wieght: bold;
            `}
          >
            인증번호와 새 비밀번호를 이력하세요.
          </Box>
          <Grid container width="100%" padding="5px">
            <TextField
              autoComplete="off"
              name="auth"
              label="인증번호"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onInputChange}
            ></TextField>
          </Grid>
          <Grid container width="100%" padding="5px">
            <TextField
              autoComplete="off"
              name="pass1"
              label="새 비밀번호 (4-12 자리 숫자, 영문자)"
              size="small"
              style={{
                width: "100%",
              }}
              type="password"
              onChange={onInputChange}
            ></TextField>
          </Grid>          
          <Grid container width="100%" padding="5px">
            <TextField
              autoComplete="off"
              name="pass2"
              label="비밀번호 확인"
              size="small"
              style={{
                width: "100%",
              }}
              type="password"
              onChange={onInputChange}
            ></TextField>
          </Grid>
          <Grid
            container
            display="flex"
            justifyContent="center"
            paddingTop="20px"
          >
            <Button
              variant="contained"
              sx={{ width: "40%", margin: "5px", background: "#0092a2" }}
              onClick={onPassReset}
            >
              암호 재설정
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: "40%",
                margin: "5px",
                border: "1px solid gray",
                color: "gray",
              }}
              onClick={onCloseFindPass}
            >
              취소
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default RegisterFindPass;
